module.exports = __webpack_public_path__ + "img/Uruguayan.e99499df.svg";